//  @flow

/** The different operators */
const Operators: StringEnum = {
  // Pays
  WAM: 'wam',
  WAMEU: 'wameu',
  WAMES: 'wames',
  WAMPT: 'wampt',
  WAMDE: 'wamde'
};

/** The different Website domains */
const Domains: StringEnum = {
  FR: 'fr',
  ES: 'es',
  PT: 'pt',
  DE: 'de'
};

// Get domain aliases
const getDomain = (operator: string) => {
  if (operator === Operators.WAMES) {
    return Domains.ES;
  } else if (operator === Operators.WAMPT) {
    return Domains.PT;
  } else {
    return Domains.FR;
  }
};

export const getApiUrl = (env: string, operator: string): string => {
  const envAlias = env === 'prod' ? '' : `.${env}`;
  const domain = getDomain(operator);

  return `https://api${envAlias}.winamax.${domain}`;
};
